import React from "react";
import { useIntl } from "@leagueplatform/locales";
import { useDocumentTitle } from "@leagueplatform/web-common";
import {
  HeadingText,
  ParagraphText,
  StackItem,
  StackLayout,
  Image,
} from "@leagueplatform/genesis-core";
import { PageHeaderBackground } from "@leagueplatform/web-common-components";
import QUEST_CIRCLE_LOGO from "assets/quest/quest_logo_circle.svg";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { PAGE_HEADER_HEIGHT, PAGE_CONTENT_MAX_WIDTH } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { useIsBelowTablet } from "hooks/use-is-below-tablet.hook";

export const AboutPage = () => {
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_ABOUT_QUEST" }));
  usePageViewAnalytics({ screen_name: "About" });

  const isBelowTablet = useIsBelowTablet();
  const headerHeight = isBelowTablet
    ? PAGE_HEADER_HEIGHT.MOBILE
    : PAGE_HEADER_HEIGHT.DESKTOP;

  return (
    <PageContentWrapper>
      <StackLayout spacing={{ "@initial": "$three", "@mobile": "$two" }}>
        <PageHeaderBackground
          height={headerHeight}
          pageHeaderBackgroundHeight={headerHeight}
          css={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <HeadingText level="1" size={{ "@initial": "xxl", "@mobile": "xl" }}>
            {formatMessage({ id: "STR_ABOUT_QUEST" })}
          </HeadingText>
        </PageHeaderBackground>

        <StackLayout
          orientation={{ "@initial": "horizontal", "@mobile": "vertical" }}
          horizontalAlignment="center"
          spacing={{ "@initial": "$twoAndHalf", "@mobile": "$two" }}
          css={{
            maxWidth: PAGE_CONTENT_MAX_WIDTH,
            "@mobile": {
              boxShadow: "0px 4px 8px -2px #18274B0F",
              padding: "$oneAndHalf",
            },
          }}
        >
          <Image
            width="98px"
            src={QUEST_CIRCLE_LOGO}
            alt={formatMessage({ id: "STR_QUEST_CIRCLE_LOGO" })}
          />
          <StackItem>
            <ParagraphText
              css={{ typography: "$bodyOne", color: "$onSurfaceTextPrimary" }}
            >
              {formatMessage({ id: "STR_ABOUT_QUEST_DESCRIPTION" })}
            </ParagraphText>
          </StackItem>
        </StackLayout>
      </StackLayout>
    </PageContentWrapper>
  );
};
